/* eslint-disable no-undef */
import React, { useContext, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { setFile, setSaveDisabled } from 'actions/modalActions';
import { alternatingBackGround } from 'helpers/styleHelpers';
import LocaleContext from 'constants/localization';
import { ARCHIVE } from 'constants/predicates';
import { isVideoType, defaultVideoJSOptions } from '../../helpers/mediaHelpers';
import VideoJS from '../../components/common/VideoJS';

import Form from 'react-bootstrap/Form';
import FieldEdit from 'field/edit/FieldEdit';
import FileInput from 'components/common/FileInput';

const ImageModal = ({ resource, setFile, setSaveDisabled }) => {
  const isPrimaryVersion = useSelector(state => state.modal.isPrimaryVersion);
  const LS = useContext(LocaleContext);
  const { validated, ref, uri, file } = resource;
  const hasFile = uri || resource.file;

  const getVideoJSOptions = (uri) => defaultVideoJSOptions(`displayContent.do?uri=${uri}`);


  // Disable save if no file
  useEffect(() => {
    setSaveDisabled(!hasFile);
    // Re-enable save if exiting modal
    return () => setSaveDisabled(false);
  }, [resource]);

  let fields = Object.values(resource.fields);
  if (isPrimaryVersion) {
    fields = fields.filter(f => f.predicate !== ARCHIVE.FINNA_PUBLISHING);
  }

  return (
    <Form validated={validated} ref={ref}>
      {
        uri && isVideoType(uri) && <div className='mediaEditVideo' > <VideoJS options={getVideoJSOptions(uri)}/> </div>
      }
      {
        uri && !isVideoType(uri) && (
          <div>
            <img src={`displayContent.do?uri=${uri}&type=thumb`} />
          </div>
        )
      }
      {
        !uri && (
          <React.Fragment>
            <FileInput 
              file={file} 
              setFile={setFile} 
              label={LS.modal.addMedia} />
            { !hasFile && <span className="text-danger">* {LS.required}</span> }
          </React.Fragment>
        )
      }
      <div style={{ marginTop: '1rem' }}>
        {
          fields.map((field, key) => (
            <div key={key} style={alternatingBackGround(key)}>
              <FieldEdit field={field} />
            </div>
          ))
        }
      </div>
    </Form>
  );
};

export default connect(null, { setFile, setSaveDisabled })(ImageModal);